import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import SelectPicker from '../../../components/SelectPicker';
import FormInput from '../../../components/FormInput';
import {ModelListSelect} from 'vue-search-select';

export default {
    components: {Datepicker, SelectPicker, FormInput, ModelListSelect},
    data() {
        return {
            date_from: null,
            date_to: null,
            privileges: [],
            passengers: [],
            cashiers: [],
            keyword: '',
            selectedCashier: null,
            selectedPassengers: [],
            selectedPassengerStatus: null,
            passengerStatuses: [
                {name: this.i18n('Everything'), id: null},
                {name: this.i18n('Village'), id: 3},
                {name: this.i18n('Not village'), id: 2},
                {name: this.i18n('Booked'), id: 1},
                {name: this.i18n('Canceled'), id: 0},
                {name: this.i18n('Returned'), id: 4},
                {name: this.i18n('other'), id: -1},
            ],
            result: [],
            all: {
                passengers_count: 0,
                passenger_amount: 0,
                tax_amount: 0, //alx
                services_count: 0,
                services_amount: 0,
                reversed_count: 0,
                reversed_amount: 0,
                ok_passenger_count: 0,
                ok_passenger_amount: 0,
                ok_passenger_bag_amount: 0,
                booked_count: 0,
            },
            loadingState: false,
            loadingPassengers: false,
            sortPassengers: null,
            sortPassengersDir: 0,
            fromError: false,
            toError: false,
            inputClass: ['form-control base_input'],
            reportData: [],
            reportDataTotal: {},
        }
    },
    created() {
        this.loadClients();
        //this.loadPrivileges();
    },
    computed: {
        startDate() {
            return this.$moment(this.date_from).startOf('day').format('Y-MM-DD');
        },
        endDate() {
            return this.$moment(this.date_to).endOf('day').format('Y-MM-DD')
        },
        selectedPassengersList() {
            return this.passengers.filter(p => {
                return this.selectedPassengers.includes(p.id);
            });
        },
        sortedPassengers() {

            let sorted = this.passengers.sort((a, b) => {
                if (this.sortPassengers === 'name') {
                    let nameA = a.full_name.toUpperCase();
                    let nameB = b.full_name.toUpperCase();
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                } else if (this.sortPassengers === 'route') {
                    let nameA = a.arriving.name.toUpperCase();
                    let nameB = b.arriving.name.toUpperCase();
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                } else if (this.sortPassengers === 'phone') {
                    if (a.phone < b.phone) return -1;
                    if (a.phone > b.phone) return 1;
                    return 0;
                } else if (this.sortPassengers === 'seat') {
                    if (a.seat_number < b.seat_number) return -1;
                    if (a.seat_number > b.seat_number) return 1;
                    return 0;
                } else if (this.sortPassengers === 'amount') {
                    if (a.amount < b.amount) return -1;
                    if (a.amount > b.amount) return 1;
                    return 0;
                } else if (this.sortPassengers === 'status') {
                    if (a.status < b.status) return -1;
                    if (a.status > b.status) return 1;
                    return 0;
                } else if (this.sortPassengers === 'trip') {
                    return new Date(b.trip.time) - new Date(a.trip.time);
                } else if (this.sortPassengers === 'created') {
                    return new Date(b.created_at) - new Date(a.created_at);
                } else if (this.sortPassengers === 'updated') {
                    return new Date(b.updated_at) - new Date(a.updated_at);
                } else if (this.sortPassengers === 'transporter') { //alx
                    let nameA = a.trip.bus.transporter.name.toUpperCase();
                    let nameB = b.trip.bus.transporter.name.toUpperCase();
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                } else {
                    return 0;
                }
            });
            if (this.keyword) {
                let keyword = this.keyword.toLowerCase();
                sorted = sorted.filter((item) => {
                    return (item.full_name && item.full_name.toLowerCase().includes(keyword)) ||
                        (item.trip && item.trip.route.name && item.trip.route.name.toLowerCase().includes(keyword)) ||
                        (item.phone && item.phone.toLowerCase().includes(keyword));
                });
            }
            if (this.selectedPassengerStatus !== null) {
                if (this.selectedPassengerStatus === -1) {
                    sorted = sorted.filter(item => {
                        return !(item.status === 0 || item.status === 1 || item.status === 2 || item.status === 3 || item.status === 4)
                    });
                } else {
                    sorted = sorted.filter(item => item.status === this.selectedPassengerStatus);
                }
            }

            return this.sortPassengersDir === 1 ? sorted.reverse() : sorted;
        }
    },
    methods: {
        loadReports() {
            let params = {
                from: this.startDate,
                to: this.endDate,
            };
            this.$api.get('reports.online-reports', params)
                .then(res => {
                    this.allReportData = res.data;
                    this.filterReport();
                    this.getTotal();
                })
        },
        getTotal() {
            this.reportDataTotal.today_count = this.reportData.reduce((sum, a) => sum + parseInt(a.today_count), 0);
            this.reportDataTotal.today_amount = this.reportData.reduce((sum, a) => sum + parseInt(a.today_amount), 0);
            this.reportDataTotal.count = this.reportData.reduce((sum, a) => sum + parseInt(a.count), 0);
            this.reportDataTotal.amount = this.reportData.reduce((sum, a) => sum + parseInt(a.amount), 0);
            this.reportDataTotal.tax_amount = this.reportData.reduce((sum, a) => sum + parseInt(a.tax_amount), 0);//alx
            this.reportDataTotal.service_count = this.reportData.reduce((sum, a) => sum + parseInt(a.service_count), 0);
            this.reportDataTotal.service_amount = this.reportData.reduce((sum, a) => sum + parseInt(a.service_amount), 0);
            this.reportDataTotal.all_count = this.reportData.reduce((sum, a) => sum + parseInt(a.today_count + a.count), 0);
            this.reportDataTotal.all_amount = this.reportData.reduce((sum, a) => sum + parseInt(a.today_amount) + parseInt(a.amount), 0);
        },
        filterReport() {
            if (this.selectedCashier && this.selectedCashier !== -1) {
                this.reportData = this.allReportData.filter(item => item.user_id === this.selectedCashier);
            } else {
                this.reportData = this.allReportData
            }
        },
        loadClients() {
            this.$api.get('reports.clientsList').then(res => {
                this.cashiers = res.data;
            }).catch()
        },
        reportCustom() {
            if (this.date_from && this.date_to) {
                this.inputClass.splice(1, 1);
                this.loadReports();
            } else {
                if (!this.date_from) {
                    this.fromError = true;
                }
                if (!this.date_to) {
                    this.toError = true;
                }
                this.inputClass.push('is-invalid');
            }
        },
        calculateAll() {

            this.all.today_passengers_count = this.result.reduce((sum, a) => sum + parseInt(a.today_passenger_count), 0);
            this.all.later_passengers_count = this.result.reduce((sum, a) => sum + parseInt(a.later_passenger_count), 0);
            this.all.passenger_cash_amount = this.result.reduce((sum, a) => sum + a.passenger_cash_amount, 0);
            this.all.tax_amount = this.result.reduce((sum, a) => sum + a.tax_amount, 0); //alx
            this.all.services_count = this.result.reduce((sum, a) => sum + a.services_count, 0);
            this.all.services_amount = this.result.reduce((sum, a) => sum + a.services_amount, 0);
            this.all.ok_passenger_count = this.result.reduce((sum, a) => sum + a.ok_passenger_count, 0);
            this.all.ok_passenger_amount = this.result.reduce((sum, a) => sum + a.ok_passenger_amount, 0);
            this.all.ok_passenger_bag_amount = this.result.reduce((sum, a) => sum + a.ok_passenger_bag_amount, 0);
            this.all.booked_count = this.result.reduce((sum, a) => sum + a.booked_count, 0);

        },
        printData() {
            let fontSize = this.$refs.printTable.style.fontSize;
            this.$refs.printTable.style.fontSize = '13.5px';
            this.displayNoneLoop = false;
            let mywindow = window.open('', 'PRINT');
            mywindow.document.write('<html><head><title>' + document.title + '</title>');
            mywindow.document.write('<link rel="stylesheet" href="/css/lib.css" />');
            mywindow.document.write('<link rel="stylesheet" href="/css/app.css" />');
            mywindow.document.write('<link rel="stylesheet" href="/print.css" />');
            mywindow.document.write('<style>table.small-padding td, table.small-padding th{padding: 3px 5px !important;}</style>');
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById('table').innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus();
            this.$refs.printTable.style.fontSize = fontSize;

            setTimeout(() => {
                mywindow.print();
                mywindow.close();
            }, 1000)
        },
        loadPassengers(id) {
            this.loadingPassengers = true;
            this.$api.post('reports.online_sales_passengers', {
                from: this.startDate,
                to: this.endDate
            }, {
                id: id
            }).then(res => {
                this.passengers = res.data.passengers;
                this.cashier = res.data.cashier;
            }).finally(() => {
                this.loadingPassengers = false;
            })
        },
        selectPassenger(id) {
            if (this.selectedPassengers.includes(id)) {
                this.selectedPassengers.splice(this.selectedPassengers.indexOf(id), 1);
            } else {
                this.selectedPassengers.push(id);
            }
        },
        checkSelected(id) {
            return this.selectedPassengers.includes(id)
        },
        changeSort(sort) {
            if (this.sortPassengers === sort) {
                this.sortPassengersDir = this.sortPassengersDir === 0 ? 1 : 0
            } else {
                this.sortPassengers = sort;
                this.sortPassengersDir = 0;
            }
        },
        bookedPassengers(arr) {
            return arr.filter(p => p.status === 1).length
        },
        boardedPassengers(arr) {
            return arr.filter(p => p.status === 3).length
        },
        notBoardedPassengers(arr) {
            return arr.filter(p => p.status === 2).length
        },
        refundedPassengers(arr) {
            return arr.filter(p => p.status === 4).length
        },
        cancelledPassengers(arr) {
            return arr.filter(p => p.status === 0).length
        },
        otherPassengers(arr) {
            return arr.filter(p => {
                return !(p.status === 0 || p.status === 1 || p.status === 2 || p.status === 3 || p.status === 4)
            }).length
        },
        sumAmountPassengers(arr) {
            return arr.reduce((s, a) => s + a.amount, 0);
        },
        exportToExcel() {
            let fileName = 'Отчет_по_продажам_' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
            this.$api.download('xls.salesReport', {
                fromDate: this.startDate,
                toDate: this.endDate,
                cashierId: this.selectedCashier,
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        exportPassengers(id) {
            let fileName = 'Отчет_по_продажам_пассажиры_' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
            this.$api.download('xls.onlineSalesPassengersReport', {
                fromDate: this.startDate,
                toDate: this.endDate,
                clientId: id,
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        reportMonthly() {
            var date = new Date();
            this.date_from = new Date(date.getFullYear(), date.getMonth(), 1);
            this.date_to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            this.reportCustom()
        },
        reportDaily() {
            this.date_from = new Date();
            this.date_to = new Date();
            this.reportCustom()
        }
    },
    mounted() {
        $('#passengersModal').on("hidden.bs.modal", () => {
                this.passengers = [];
                this.cashier = null;
                this.sortPassengers = null;
                this.sortPassengersDir = 0;
                this.keyword = '';
                this.selectedCashier = null;
                this.selectedPassengers = [];
                this.selectedPassengerStatus = null;
            }
        );
    },
    filters: {
        moneyFormat(num) {
            if (!num) {
                return 0;
            }
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        },
        passengerStatus(v) {
            if (v === 1) {
                return 'Бронирован'
            } else if (v === 2) {
                return 'Не приехал'
            } else if (v === 3) {
                return 'Приехал'
            } else if (v === 4) {
                return 'Возвращено'
            } else if (v === 0) {
                return 'Отменил за неуплату'
            } else {
                return v
            }
        },
    },
    watch: {
        selectedCashier: function () {
            this.filterReport();
        }
    }
}
